import { useContext } from 'react';

import { CurrentUserWorkflowTrackersContext } from './CurrentUserWorkflowTrackersContext.context';

export function useCurrentUserWorkflowTrackersContext() {
  const context = useContext(CurrentUserWorkflowTrackersContext);
  if (!context) {
    throw new Error(
      'useCurrentUserWorkflowTrackersContext must be used within a CurrentUserWorkflowTrackersProvider'
    );
  }
  return context;
}
